<script>
export default {
    name: "PatientTreatment",

    data() {

        return {
            prescriptions: [],
        };
    },

    props: {

        patient: {
            type: Object,
            required: true,
        },
    },

    mounted() {
        this.$root.loading = true;
        Promise.all([ this.fetchMFPrescriptions(), ]).then(() => {
            this.$root.loading = false;
        }).catch(() => { this.$root.loading = false; });
    },

    methods: {

        fetchMFPrescriptions() {

          let url = `MedicalFile/GetPatientDrugsandConsumblesTreatment`;
          url += `?PatientID=${this.patient.patienT_ID}`;
          url += `&VisitNo=${this.patient.visitNo}`;

          return this.$http
            .get(url)
            .then(({ data }) => {
              this.prescriptions = data;
            })
            .catch(() => {});
        },
    },
}
</script>
<template>
    <div class="w-full overflow-auto">
        <table class="table table-hover">
          <thead class="bg-blue-500 text-sm text-white">
            <tr class="flex w-full">
              <th class="p-tiny flex-1">Date</th>
              <th class="p-tiny flex-1">Drug</th>
              <th class="p-tiny flex-1">Is Discharge</th>
              <th class="p-tiny flex-1">Description</th>
              <th class="p-tiny flex-1">Requested By</th>
            </tr>
          </thead>
          <tbody
            class="text-sm bg-gray-100 flex flex-col bg-gray-100 overflow-auto"
            style="max-height:30vh;"
          >
            <tr
              class="w-full flex"
              v-for="(pres, idx) in prescriptions"
              :key="idx"
            >
              <td class="p-tiny flex-1">{{ pres.date | dateFormat }}</td>
              <td class="p-tiny flex-1">{{ pres.drug }}</td>
              <td class="p-tiny flex-1">
                {{ pres.isDischarge ? `Yes` : `No` }}
              </td>
              <td class="p-tiny flex-1">{{ pres.description }}</td>
              <td class="p-tiny flex-1">{{ pres.requested_By }}</td>
            </tr>
          </tbody>
        </table>
    </div>
</template>
